import { Component, Host, h, Prop, State } from '@stencil/core';
import { Swiper, SwiperOptions, Autoplay, Pagination, Navigation } from 'swiper';
import { hexToRgb, getCSSVarValue } from './../../../utils/utils';

@Component({
  tag: 'afs-sweep-banner',
  styleUrl: 'afs-sweep-banner.scss',
  shadow: false,
  scoped: false,
})
export class AfsSweepBanner {

  dynamicContent! : HTMLElement;
  nextEl! : HTMLElement;
  prevEl! : HTMLElement;
  swiperContainer! : HTMLElement;

  @Prop() fr : boolean = false;

  @Prop() langButtonShow : string = this.fr ? "MONTRER TOUT" : "SHOW ALL";
  @Prop() langButtonHide : string = this.fr ? "CACHER" : "HIDE";

  @Prop() contentType : 'dynamic' | 'static' = 'dynamic';
  @Prop() autoplay : boolean = false;
  @Prop() swiperSpeed : number = 700;
  @Prop() swiperDelay : number = 4000;

  @Prop() bulletActiveColor : string = "#000000";
  @Prop() bulletNonactiveColor : string = "#dddddd";
  @Prop() showAllDividerColor : string = "#888888";
  @Prop() buttonBackgroundColor : string = "#222222";
  @Prop() buttonColor : string = "#FFFFFF";
  @Prop() gradientColor : string = "#FFFFFF";

  swiperParams : SwiperOptions = {
    loop: true,
    speed: this.swiperSpeed,
    slidesPerView: 1.2,
    centeredSlides: true,
    pagination: {
      el: '.swiper-pagination.swiper-pagination-sweep',
      type: 'bullets',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 1.6
      },
      1024: {
        slidesPerView: 2
      }
    },
  }

  @State() swiper : Swiper = null;
  @State() allShown : boolean = false;
  @State() currentPage = 0;

  componentWillLoad() {
    if (this.gradientColor.includes('var(')) {
        this.gradientColor = getCSSVarValue(this.gradientColor);
    }
  }

  componentDidLoad() {
    Swiper.use([Autoplay, Pagination, Navigation]);
    this.swiper = new Swiper(this.swiperContainer, {...this.swiperParams, navigation: {
      nextEl: this.nextEl,
      prevEl: this.prevEl,
    }, autoplay: this.autoplay ? { delay: this.swiperDelay } : false});

    const dynamicContentChildren = Array.from(this.dynamicContent.children);

    if (dynamicContentChildren.length < 1) return;

    dynamicContentChildren.forEach((content : Element, index) => {
        content.classList.add(this.contentType == "static" ? "sweep-banner-show-all-content" : index > 0 ? 'sweep-banner-hidden-content' : 'sweep-banner-active-content');
    })
    if (this.contentType == "static") return;
    
    this.swiper.on('slideChange', (e) => this.updateDynamicContent(e, dynamicContentChildren))

  }

  updateDynamicContent(e, contents : Element[]) {
    this.currentPage = e.realIndex;
    contents.forEach((content : Element, index) => {
      content.className = index == this.currentPage ? "sweep-banner-active-content" : "sweep-banner-hidden-content";
    })
    this.allShown = false;
  }

  toggleContent() {
    const dynamicContentChildren = Array.from(this.dynamicContent.children);
    dynamicContentChildren.forEach((content : Element, index) => {
      content.className = !this.allShown ? "sweep-banner-show-all-content" : index == this.currentPage ? "sweep-banner-active-content" : "sweep-banner-hidden-content";
    })
    this.allShown = !this.allShown;
  }

  render() {
    const gRGB = hexToRgb(this.gradientColor);
    return (
      <Host style={{
        '--show-all-border-color': this.showAllDividerColor,
      }}>
        <div class="swiper-container swiper-container-sweep" ref={el => this.swiperContainer = el as HTMLElement} style={{
          '--gradient-R': gRGB.r.toString(),
          '--gradient-G': gRGB.g.toString(),
          '--gradient-B': gRGB.b.toString(),
        }}>
          <div class="swiper-wrapper swiper-wrapper-sweep">
            <slot></slot>
          </div>
          <div class="swiper-pagination swiper-pagination-sweep" style={{
            '--bullet-active-color' : this.bulletActiveColor,
            '--bullet-nonactive-color' : this.bulletNonactiveColor,
          }}></div>
          <div class="sweep-banner-navigation-prev sweep-banner-navigation" ref={el => this.prevEl = el as HTMLElement}></div>
          <div class="sweep-banner-navigation-next sweep-banner-navigation" ref={el => this.nextEl = el as HTMLElement}></div>
        </div>
        <div class="swiper-sweep-dynamic-content" ref={el => this.dynamicContent = el as HTMLElement}>
          <slot name="dynamic-content"></slot>
        </div>
        { this.contentType == 'dynamic' && <div><afs-button color={this.buttonColor} backgroundColor={this.buttonBackgroundColor} onClick={() => this.toggleContent()}>{ this.allShown ? this.langButtonHide : this.langButtonShow }</afs-button><br/></div>}
      </Host>
    );
  }

}
